if (!customElements.get('product-bundle-form')) {
  customElements.define(
    'product-bundle-form', class ProductBundleForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="button"]');
        this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this));
        this.productDataJson = JSON.parse(this.querySelector('[data-product-json]').textContent);
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const productQuantity = new FormData(this.form).get('quantity') || 1;
        const formData = this.formatFormData(productQuantity);

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.submitButton.querySelector('span').style.visibility = 'hidden';
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: `application/json`,
          },
          body: JSON.stringify(formData)
        }

        try {
          const res = await fetch(routes.cart_add_url + '.js', config)
          const json = await res.json();

          if (res.status !== 200) throw new Error(json.description);

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              json: json
            }
          }));

          const {
            title: bundleTitle,
            handle: bundleHandle,
          } = this.productDataJson.product;

          json.items.forEach(item => {
            const jsonDataElement = document.querySelector(`.bundle-child[data-product-id="${item.product_id}"] [data-child-product-json]`);

            if (!jsonDataElement) return;

            const productDetails = JSON.parse(jsonDataElement.textContent);

            document.dispatchEvent(new CustomEvent('datalayer:productAdded', {
              detail: {
                product: productDetails,
                quantity: productQuantity ? parseInt(productQuantity) : 1,
                price: item.price,
                bundled: true,
                bundleProduct: {
                  title: bundleTitle,
                  handle: bundleHandle
                }
              }
            }));
          });


          const products = json.items
              .map(item => ({
                  id: item.sku,
                  price: Number.parseInt(item.line_price * (100 - item.properties._bundleDiscountPercentage) / 100, 10),
                  quantity: item.quantity,
                  category: 'bundle'
                }));

            document.dispatchEvent(new CustomEvent('snowplow:productBundleAdded', {
              detail: {
                products,
                total_value: products.reduce((acc, curr) => acc + curr.price, 0),
              }
            }));

        } catch(error) {
          this.handleErrorMessage(error);
          console.error(error);
        }

        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.querySelector('span').style.visibility = 'visible';
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      formatFormData(quantity) {
        const formData = { items: [] };
        const giftWrapping = document.querySelector('gift-wrapping');
        const giftWrappingId = giftWrapping && giftWrapping.querySelector('.disclosure__link--active') ? giftWrapping.querySelector('.disclosure__link--active').dataset.value : '';
        let giftWrappingName = '';

        const childrenPicker = document.querySelector('children-picker');
        const variantSelects = Array.from(childrenPicker.querySelectorAll('variant-selects'));

        const {
          id: bundleId,
          handle: bundleHandle,
          title: bundleTitle,
          featured_image: bundleImage
        } = this.productDataJson.product;

        const productTitles = variantSelects.map(variantSelect => variantSelect.productTitle);
        const variantTitles = variantSelects.map(variantSelect => variantSelect.currentVariant.public_title);
        const variantIds = variantSelects.map(variantSelect => variantSelect.currentVariant.id);
        const productIds = variantSelects.map(variantSelect => variantSelect.productId);

        if (giftWrappingId) {
          giftWrappingName = giftWrapping.querySelector('.disclosure__link--active').dataset.name;

          const itemProperties = {
            '_giftWrapping': true,
            '_parentKey': window.btoa([bundleId, ...variantIds, giftWrappingId].join(',')),
            'Product': bundleTitle
          };

          formData.items.push({
            id: giftWrappingId,
            quantity,
            properties: itemProperties
          });
        }

        const bundleDiscountPercentage = parseFloat(childrenPicker.getAttribute('discount'))

        const bundlePrices = variantSelects
          .reduce((prices, { currentVariant: { compare_at_price, price } }) => {
            prices.compare_at_price += compare_at_price || price
            prices.price += price;
            return prices;
          }, { compare_at_price: 0, price: 0 })

        const expectedPrice = bundlePrices.compare_at_price * (1 - bundleDiscountPercentage / 100)
        const additionalDiscount = (1 - (expectedPrice / bundlePrices.price)) * 100

        variantSelects.forEach(variantSelect => {
          const { currentVariant } = variantSelect;
          const itemProperties = {
            '_bundleDiscountPercentage': Math.max(additionalDiscount, 0),
            '_bundleId': bundleId,
            '_bundleHandle': bundleHandle,
            '_bundleTitle': bundleTitle,
            '_bundleImageUrl': bundleImage,
            '_bundleItems': childrenPicker.getAttribute('handles'),
            '_bundleKey': window.btoa([bundleId, ...variantIds, giftWrappingId].join(',')),
            '_bundleProductIds': productIds.join(','),
            '_bundleProductTitles':  productTitles.join(','),
            '_bundleVariantsTitles':  variantTitles.join(','),
            '_bundleLocale': Shopify.locale,
            ...giftWrappingId ? {
              '_giftWrappingId': giftWrappingId
            } : ''
          };

          // It will be hidden on storefront, but visible on single products on email transactions
          if (giftWrappingId) {
            itemProperties['_giftWrappingId'] = giftWrappingId;
            itemProperties[window.variantStrings.gift_wrapping.wrapping_property_label || 'Gift wrapping'] = giftWrappingName;
          }

          if (window.variantStrings.bundle_discount) {
            itemProperties[window.variantStrings.bundle_discount] = `-${parseFloat(childrenPicker.getAttribute('discount'))}%`;
          }
          if (window.variantStrings.bundle_product) {
            itemProperties[window.variantStrings.bundle_product] = bundleTitle;
          }

          formData.items.push({
            id: currentVariant.id,
            quantity,
            properties: itemProperties
          });
        });

        return formData;
      }
    }
  );
}
